import { BaseConfig } from "../config.interface";
import { Size, Validate } from "../util";

interface IInputTextConfig {
    label?: string;
    minlength?: number;
    maxlength?: number;
    autocomplete?: string;
    size: Size | "full";
    validate: Validate;
}
export class InputTextConfig extends BaseConfig<IInputTextConfig> implements IInputTextConfig {
    /**
     * Label of the element.
     */
    label?: string;
    /**
     * Min length of the value.
     */
    minlength?: number;
    /**
     * Max length of the value.
     * @note May be overwritten by a formControl validator
     */
    maxlength?: number;
    /**
     * Browser autocomplete attribute.
     */
    autocomplete?: string;
    /**
     * Size of the input element.
     * @values "small" | "medium" | "large"
     */
    size: Size | "full";
    /**
     * Show validation status already in `pristine` state or after it has been marked as `dirty`.
     */
    validate: Validate;

    /**
     * @theme Base
     */
    static baseTheme = {
        /**
         * Default configuration.
         * Has medium input size.
         */
        Default: new InputTextConfig({
            size:     "medium",
            validate: "dirty",
        }),

        /**
         * Small input size.
         */
        Small: new InputTextConfig({
            size:     "small",
            validate: "dirty",
        }),

        /**
         * Medium input size. 
         */
        Medium: new InputTextConfig({
            size:     "medium",
            validate: "dirty",
        }),

        /**
         * Large input size.
         */
        Large: new InputTextConfig({
            size:     "large",
            validate: "dirty",
        }),

        /**
         * Only use this if it cannot be avoided.
         * We want to avoid full width inputs in most cases.
         */
        Full: new InputTextConfig({
            size:     "full",
            validate: "dirty",
        }),

        /**
         * Use this for name/title fields in steppers.
         */
        Name: new InputTextConfig({
            size:      "large",
            validate:  "dirty",
            label:     "Name",
            maxlength: 30,
        }),

        /**
         * Example for autocomplete
         */
        Username: new InputTextConfig({
            size:         "large",
            validate:     "dirty",
            autocomplete: "username",
        }),

        OneTimeCode: new InputTextConfig({
            size:         "large",
            validate:     "dirty",
            autocomplete: "one-time-code",
        }),

        PristineMedium: new InputTextConfig({
            size:     "medium",
            validate: "pristine",
        }),
    };

}